const ALIGN = 'center'

const disabled = [
  {
    title: '计划',
    key: 'planName_1',
    type: 'disabled',
    align: 'left',
    width: 100,
    overflow: true
  },
  {
    title: '素材',
    key: 'imageName_1',
    type: 'disabled',
    align: 'left',
    width: 72,
    overflow: true
  },
  {
    title: '平台',
    key: 'platform_1',
    type: 'disabled',
    align: 'left',
    overflow: true,
    width: 84
  },
  {
    title: '应用组',
    key: 'gameGroupName_1',
    width: 80,
    align: 'left',
    overflow: true,
    type: 'disabled'
  },
  {
    title: '应用',
    type: 'disabled',
    key: 'gameName_1',
    align: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '项目组',
    type: 'disabled',
    key: 'projectGroupName_1',
    align: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '人员',
    type: 'disabled',
    key: 'opName_1',
    align: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '媒体',
    type: 'disabled',
    key: 'mediaName_1',
    align: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '投放位',
    type: 'disabled',
    key: 'advPositionName_1',
    align: 'left',
    width: 74,
    overflow: true
  },
  {
    title: '账号',
    type: 'disabled',
    key: 'adAccountName_1',
    align: 'left',
    width: 140,
    overflow: true
  },
  {
    title: '优化目标',
    type: 'disabled',
    key: 'optimizationTypeName_1',
    align: 'left',
    width: 90,
    overflow: true
  },
  {
    title: '深度优化目标',
    type: 'disabled',
    key: 'deepOptimizationTypeName_1',
    align: 'left',
    width: 70,
    overflow: true
  },
  {
    title: '流量来源',
    type: 'disabled',
    key: 'launchSourceName_1',
    align: 'left',
    width: 90,
    overflow: true
  }
]

export const complexRestCols = [
  // {
  //   title: '广告位',
  //   key: 'advPositionName',
  //   type: 'report',
  //   sortable: 'custom',
  //   align: ALIGN,
  //   width: 80
  // },
  {
    title: '账面消耗',
    key: 'paperConsume',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '实际消耗',
    key: 'realConsume',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '新建计划数',
    key: 'newPlanNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '在跑计划数',
    key: 'runPlanNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '无效消耗',
    key: 'invalidConsume',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '无效消耗率',
    key: 'invalidConsumeRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '展示量',
    key: 'pv',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '点击量',
    key: 'clickNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '点击成本',
    key: 'clickCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '点击率',
    key: 'clickRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '激活数',
    key: 'activeNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '激活成本',
    key: 'activeCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '注册数',
    key: 'registerNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '注册成本',
    key: 'registerCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '创角账号数',
    key: 'createRoleNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角成本',
    key: 'createRoleCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 80
  },
  {
    title: '角色数',
    key: 'newRoleNum',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角账号率',
    key: 'newRoleRate',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '首日付费创角数',
    key: 'payRole1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费次数',
    key: 'newRolePayCnt1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费成本',
    key: 'payRoleCost1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日每次付费成本',
    key: 'payRoleEveryCost1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角付费率',
    key: 'payRoleRate1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角充值金额',
    key: 'createRoleMoney1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '首日创角ROI',
    key: 'newRoleRoi1d',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日付费次数',
    key: 'newRoleSevenDayPayCnt',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '7日每次付费成本',
    key: 'newRoleSevenDayPayCntCost',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计付费创角数',
    key: 'payRoleNd',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计付费次数',
    key: 'payRoleCntNd',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计创角付费成本',
    key: 'payRoleCostNd',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '累计每次付费成本',
    key: 'payRoleEveryCostNd',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '新创角累计充值',
    key: 'createRoleTotalMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '新创角累计ROI',
    key: 'createRoleTotalRoi',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '新创角累计天数',
    key: 'createRoleDays',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },

  {
    title: '自然时段创角充值金额',
    key: 'natureTimeNewRoleMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '自然时段新创角ROI',
    key: 'natureTimeNewRoleRoi',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '总流水',
    key: 'totalMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '转端流水',
    key: 'transMoney',
    type: 'report',
    sortable: 'custom',
    align: ALIGN,
    width: 72
  },
  {
    title: '创角账号1日留',
    key: 'createRoleRetain1d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日留',
    key: 'createRoleRetain2d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日留',
    key: 'createRoleRetain3d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日留',
    key: 'createRoleRetain4d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日留',
    key: 'createRoleRetain5d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日留',
    key: 'createRoleRetain6d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日留',
    key: 'createRoleRetain7d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日留',
    key: 'createRoleRetain15d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日留',
    key: 'createRoleRetain30d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日留',
    key: 'createRoleRetain60d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日留',
    key: 'createRoleRetain90d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日留',
    key: 'createRoleRetain120d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日留',
    key: 'createRoleRetain150d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日留',
    key: 'createRoleRetain180d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日留',
    key: 'createRoleRetain210d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日留',
    key: 'createRoleRetain240d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日留',
    key: 'createRoleRetain270d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日留',
    key: 'createRoleRetain300d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日留',
    key: 'createRoleRetain330d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日留',
    key: 'createRoleRetain360d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号1日LTV',
    key: 'createRoleLtv1d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日LTV',
    key: 'createRoleLtv2d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日LTV',
    key: 'createRoleLtv3d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日LTV',
    key: 'createRoleLtv4d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日LTV',
    key: 'createRoleLtv5d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日LTV',
    key: 'createRoleLtv6d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日LTV',
    key: 'createRoleLtv7d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日LTV',
    key: 'createRoleLtv15d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日LTV',
    key: 'createRoleLtv30d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日LTV',
    key: 'createRoleLtv60d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日LTV',
    key: 'createRoleLtv90d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日LTV',
    key: 'createRoleLtv120d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日LTV',
    key: 'createRoleLtv150d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日LTV',
    key: 'createRoleLtv180d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日LTV',
    key: 'createRoleLtv210d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日LTV',
    key: 'createRoleLtv240d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日LTV',
    key: 'createRoleLtv270d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日LTV',
    key: 'createRoleLtv300d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日LTV',
    key: 'createRoleLtv330d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日LTV',
    key: 'createRoleLtv360d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号1日ROI',
    key: 'createRoleRoi1d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日ROI',
    key: 'createRoleRoi2d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日ROI',
    key: 'createRoleRoi3d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日ROI',
    key: 'createRoleRoi4d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日ROI',
    key: 'createRoleRoi5d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日ROI',
    key: 'createRoleRoi6d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日ROI',
    key: 'createRoleRoi7d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日ROI',
    key: 'createRoleRoi15d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日ROI',
    key: 'createRoleRoi30d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日ROI',
    key: 'createRoleRoi60d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日ROI',
    key: 'createRoleRoi90d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日ROI',
    key: 'createRoleRoi120d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日ROI',
    key: 'createRoleRoi150d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日ROI',
    key: 'createRoleRoi180d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日ROI',
    key: 'createRoleRoi210d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日ROI',
    key: 'createRoleRoi240d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日ROI',
    key: 'createRoleRoi270d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日ROI',
    key: 'createRoleRoi300d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日ROI',
    key: 'createRoleRoi330d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日ROI',
    key: 'createRoleRoi360d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号1日付费留存',
    key: 'payRoleRetain1d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号2日付费留存',
    key: 'payRoleRetain2d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号3日付费留存',
    key: 'payRoleRetain3d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号4日付费留存',
    key: 'payRoleRetain4d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号5日付费留存',
    key: 'payRoleRetain5d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号6日付费留存',
    key: 'payRoleRetain6d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号7日付费留存',
    key: 'payRoleRetain7d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号15日付费留存',
    key: 'payRoleRetain15d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号30日付费留存',
    key: 'payRoleRetain30d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    width: 100
  },
  {
    title: '创角账号60日付费留存',
    key: 'payRoleRetain60d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号90日付费留存',
    key: 'payRoleRetain90d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号120日付费留存',
    key: 'payRoleRetain120d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号150日付费留存',
    key: 'payRoleRetain150d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号180日付费留存',
    key: 'payRoleRetain180d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号210日付费留存',
    key: 'payRoleRetain210d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号240日付费留存',
    key: 'payRoleRetain240d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号270日付费留存',
    key: 'payRoleRetain270d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号300日付费留存',
    key: 'payRoleRetain300d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号330日付费留存',
    key: 'payRoleRetain330d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  },
  {
    title: '创角账号360日付费留存',
    key: 'payRoleRetain360d',
    type: 'other',
    sortable: 'custom',
    align: ALIGN,
    auth: 'M21052',
    width: 100
  }
]

export default disabled.concat(complexRestCols)
